import axios from 'axios';

const removeDiacritics = require('diacritics').remove;

export default {
    getPrivateMessageChannels(context) {
    var options = {
            url: window.chatUrl + '/api/v1/im.list.everyone',
            method: 'GET',
            headers: {
                'X-Auth-Token': localStorage.rocket_token,
                'X-User-Id': localStorage.rocket_id
            }
      
        };
        return axios.request(options).then(function(response) {
            return response;        
        }).catch(function(e) {
            return e;
        })
    },
    getActiveUsers(context) {
    // var options = {
    //         url: window.chatUrl + '/api/v1/users.list',
    //         method: 'GET',
    //         headers: {
    //             'X-Auth-Token': localStorage.rocket_token,
    //             'X-User-Id': localStorage.rocket_id
    //         }
      
    //     };
    //     return axios.request(options).then(function(response) {
    //         return response;        
    //     }).catch(function(e) {
    //         return e;
    //     })
    },
    rocketLogin(context, credentials) {
        let data = {
            email: credentials.username,
            password: credentials.password
        }

        // if (localStorage.intake && localStorage.intake != 'null') {
        //     data.intake = localStorage.intake;
        // }
        // if (localStorage.group && localStorage.group != 'null') {
        //     data.groups = localStorage.group;
        // }

        // data.scope = localStorage.roles;

        var options = {
            url: window.chatUrl + '/api/v1/login',
            method: 'POST',
            data:data
        };
        return axios.request(options).then(function(response) {
            console.log(response);
            return response;        
        }).catch(function(e) {
            return e;
        })
    },
    rocketLogout(context, credentials) {
        var options = {
            url: window.chatUrl + '/api/v1/logout',
            method: 'GET',
            headers: {
                'X-Auth-Token': localStorage.rocket_token,
                'X-User-Id': localStorage.rocket_id
            }
      
        };
        return axios.request(options).then(function(response) {
            return response;        
        }).catch(function(e) {
            return e;
        })
    },
    setRocketAvatar(context, avatar) {
        var options = {
            url: window.chatUrl + '/api/v1/users.setAvatar',
            method: 'POST',
            data: {avatarUrl: avatar},
            headers: {
                'X-Auth-Token': localStorage.rocket_token,
                'X-User-Id': localStorage.rocket_id
            }
      
        };
        return axios.request(options).then(function(response) {
            return response;        
        }).catch(function(e) {
            return e;
        })
    },
    registerRocketChat(context, credentials) {
        let data = {
            username: removeDiacritics(localStorage.user_name.replace(/ /g, '_')).toLowerCase(),
            name: removeDiacritics(localStorage.user_name),
            email: credentials.username,
            pass: credentials.password,
            secretURL: 'RGF42wLFeiYPZ9Ggc'
        }

        if (localStorage.intake && localStorage.intake != 'null') {
            data.intake = localStorage.intake;
        }
        // if (localStorage.group && localStorage.group != 'null') {
        //     data.groups = localStorage.group;
        // }

        var options = {
            url: window.chatUrl + '/api/v1/users.register',
            method: 'POST',
            data:data
        };
        return axios.request(options).then(function(response) {
            console.log(response);
            return response;        
        }).catch(function(e) {
            console.log(e);
            return e;
        })
    },
    getConversations(context) {

        var options = {
            url: window.apiUrl + '/conversations',
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });

    },
    getConversation(context, counterparts, page, lastId) {
        console.log(lastId);
        var self = this;
        var url = window.apiUrl + '/conversation?user=' + localStorage.uuid;
        
        counterparts.forEach(function(counterpart) {
            url += '&counterpart=' + counterpart + '&page=' + page + "&last_id=" + lastId
        });

        var options = {
            url: url,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };

        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    markAsRead(context, data) {
        var options = {
            url: window.apiUrl + '/chat-message',
            method: 'PATCH',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },

    createGroup(context, name, creator, users) {
        var data = {
            users: users,
            name: name,
            creator: creator
        }

        var options = {
            url: window.apiUrl + '/chat-group',
            method: 'POST',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },

    deleteGroup(context, groupId) {
        console.log(groupId);
        var options = {
            url: window.apiUrl + '/chat-group/' + groupId,
            method: 'DELETE',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getGroups(context, uuid) {
       var options = {
            url: window.apiUrl + '/chat-groups?uuid=' + uuid,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    getGroupMessages(context, lastId, groupId) {
       var options = {
            url: window.apiUrl + '/chat-group-messages?last_id=' + lastId + '&groupId=' + groupId,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    }


};



// WEBPACK FOOTER //
// ./src/services/chat/index.js